<template>
  <div class="native"> 
      <div ><img  class='logo' src='../assets/ic-logo-drive.svg' /></div>
      <div class='menu1'>
          <a href='#'>starred</a>
          <a href='#'>trash</a>
      </div>
      <div class='headerLast'>
        <input  class='inputN'/>
        <md-icon class='inputN_icon'>search</md-icon>
      </div>
  </div>
</template>



<script>
export default {
  name: 'Native',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .native{
    background-color: #FFF;
    max-height: 96px;
    border: 0px;
    border-style: solid;
    padding: 25px 85px 25px 85px;
    display: flex;
    flex-direction: row;
  }

  .logo{
    width:154px;
    height:47px;
  }
  .menu1{
    margin-left: 30px;
    display: flex;
    flex-direction: row;
    align-items: center;
  }


  .menu1 > a{
    text-transform: uppercase;
    font-style:"Open Sans" #000;
    font-size:16x;
    text-align: center;
    color:#000000;
    margin:10px;

  }


  .headerLast{
    align-self: right;
    width:45%;
    position: relative;
    margin-left:auto;
  }
  .inputN{
    display: flex;
    width: 100%;
    height: 48px;
    background: #EFEFEF;
    border-radius: 24px;
    padding-left:20px;
    border:0px;
    font-size:30px;
     position:relative;
  }

  .inputN_icon {
    right:30px;
    top:15px;
    position: absolute;;
  }
</style>
